import request from '@/utils/http';
import { SRM, SRM_FILE } from '../constant/constant.js';


// 委派函列表
export const supplierDelegateManageRecordPage = data => {
    return request({
        url: `${SRM}/supplierDelegateManageRecordPage`,
        method: 'post',
        data
    });
};

// 委派函详情
export const supplierDelegateManageRecordDetail = data => {
    return request({
        url: `${SRM}/supplierDelegateManageRecordDetail`,
        method: 'post',
        data
    });
};

// 发起供应商签署
export const supplierDelegateManageRecordPush = data => {
    return request({
        url: `${SRM}/supplierDelegateManageRecordPush`,
        method: 'post',
        data
    });
};

// 委派函导出
export const exportSupplierDelegateManageRecord = data => {
    return request({
        url: `${SRM_FILE}/exportSupplierDelegateManageRecord`,
        method: 'post',
        data
    });
};

// 委派函重推
export const supplierDelegateManageRecordRePush = params => {
    return request({
        url: `${SRM}/supplierDelegateManageRecordRePush`,
        method: 'get',
        params
    });
};
